import { Helmet } from "react-helmet";
import PropTypes from "prop-types";

const Meta = ({ title }) => {
    return (
        <Helmet>‍
            <title>{title} - Anonymous Proxy</title>
            <link rel="icon" href="/images/universal/logo.png" media="logo" />
            <meta httpEquiv="X-UA-Compatible" content="IE=Edge, chrome" />
            <meta httpEquiv="Content-Type" content="text/html;charset=UTF-8" />‍
            <meta name="keywords" content="Anonymous Proxies, Proxy and Socks 5" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta name="description" content="Buy anonymous proxy shared dedicated or residential starting at just $0.7" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="https://anonymous-proxies.net" />
            <meta name="twitter:creator" content="anonymous proxies" />
            <meta name="twitter:title" content="Anonymous Proxies - Buy anonymous proxy shared dedicated or residential" />
            <meta name="twitter:description" content="Buy anonymous proxy shared dedicated or residential starting at just $0.7" />
            <meta name="twitter:image" content="Anonymous Proxies" />
            <meta property="og:title" content="Anonymous Proxies" />
            <meta property="og:description" content="Buy anonymous proxy shared dedicated or residential starting at just $0.7" />
            <meta property="og:image" content="anonymous-proxies" />
            <meta property="og:url" content="https://anonymous-proxies.net" />
            <meta property="og:site_name" content="Anonymous Proxies" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="product services" />
        </Helmet>
    );
};

Meta.propTypes = { title: PropTypes.string.isRequired };

export default Meta;